export enum CryptoCurrency {
  Fan = 'fan',
  Bnb = 'bnb',
  Matic = 'matic',
}
